import { rootApi } from '../rootApi';

export const dealerInvoiceEntryApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        // Adım 1: SAP'den gelen işlenmemiş kayıtlar 
        getAvailableSapDocuments: builder.query({
            query: (params) => {
                const queryParams = new URLSearchParams();
                queryParams.append('PageNumber', params.pageNumber || 1);
                queryParams.append('PageSize', params.pageSize || 10);
                queryParams.append('LanguageId', params.languageId || 1);
                if (params.groupId) queryParams.append('GroupId', params.groupId);
                if (params.dealerCode) queryParams.append('DealerCode', params.dealerCode);
                if (params.invoiceNumber) queryParams.append('InvoiceNumber', params.invoiceNumber);
                if (params.startDate) queryParams.append('StartDate', params.startDate);
                if (params.endDate) queryParams.append('EndDate', params.endDate);
                return {
                    url: `v1/DealerInvoiceApproval/dealer/available-documents?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: ['AvailableDocuments']
        }),
        // Garanti Ekibi: Tüm bayilerin işlenmemiş SAP kayıtları
        getAllAvailableSapDocumentsForWarrantyTeam: builder.query({
            query: (params) => {
                const queryParams = new URLSearchParams();
                queryParams.append('PageNumber', params.pageNumber || 1);
                queryParams.append('PageSize', params.pageSize || 10);
                queryParams.append('LanguageId', params.languageId || 1);
                if (params.groupId) queryParams.append('GroupId', params.groupId);
                if (params.dealerCode) queryParams.append('DealerCode', params.dealerCode);
                return {
                    url: `v1/DealerInvoiceApproval/warranty-team/all-available-documents?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: ['AvailableDocuments']
        }),
        // Adım 4 & 7: Onay Süreci ve Geçmişi
        getDealerInvoiceHistory: builder.query({
            query: (params) => {
                const queryParams = new URLSearchParams();
                queryParams.append('PageNumber', params.pageNumber || 1);
                queryParams.append('PageSize', params.pageSize || 10);
                queryParams.append('LanguageId', params.languageId || 1);
                if (params.status !== null && params.status !== undefined) {
                    queryParams.append('Status', params.status);
                }
                if (params.groupId) queryParams.append('GroupId', params.groupId);
                if (params.dealerCode) queryParams.append('DealerCode', params.dealerCode);
                if (params.invoiceNumber) queryParams.append('InvoiceNumber', params.invoiceNumber);
                if (params.startDate) queryParams.append('StartDate', params.startDate);
                if (params.endDate) queryParams.append('EndDate', params.endDate);
                return {
                    url: `v1/DealerInvoiceApproval/dealer/my-submissions?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: ['DealerInvoiceHistory']
        }),

        // Adım 3: Onaya Gönderme
        createDealerInvoice: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/dealer/submit',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['AvailableDocuments', 'DealerInvoiceHistory']
        }),

        // Adım 4 (İade): İade edilen kaydı güncelleme 
        updateDealerInvoice: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/dealer/update-returned',
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['DealerInvoiceHistory']
        }),

        saveDealerInvoiceDraft: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/dealer/save-draft',
                method: 'POST',
                body: data
            }),
            transformResponse: (response) => response?.data ?? response,
            invalidatesTags: ['AvailableDocuments', 'DealerInvoiceHistory']
        }),

        updateDealerInvoiceDraft: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/dealer/update-draft',
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['DealerInvoiceHistory']
        }),

        submitDealerInvoiceDraft: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/dealer/submit-draft',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['DealerInvoiceHistory', 'AvailableDocuments']
        }),
        // 1. Doküman Yükle
        uploadInvoiceDocument: builder.mutation({
            query: (formData) => ({
                url: 'v1/DealerInvoiceApproval/document/upload',
                method: 'POST',
                body: formData
            }),
            invalidatesTags: ['InvoiceDocuments']
        }),
        // 2. Doküman Getir
        getInvoiceDocumentById: builder.query({
            query: (documentId) => ({
                url: `v1/DealerInvoiceApproval/document/${documentId}`,
                method: 'GET'
            }),
            providesTags: ['InvoiceDocuments']
        }),

        // 3. Doküman Sil
        deleteInvoiceDocument: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/DeleteDocument',
                method: 'DELETE',
                body: data
            }),
            invalidatesTags: ['InvoiceDocuments']
        }),

        // Garanti Ekibi: Onay Bekleyen Faturalar
        getPendingApprovalsForWarrantyTeam: builder.query({
            query: (params) => {
                const queryParams = new URLSearchParams();
                queryParams.append('PageNumber', params.pageNumber || 1);
                queryParams.append('PageSize', params.pageSize || 10);
                queryParams.append('LanguageId', params.languageId || 1);
                if (params.status !== null && params.status !== undefined) {
                    queryParams.append('Status', params.status);
                }
                if (params.groupId) queryParams.append('GroupId', params.groupId);
                if (params.dealerCode) queryParams.append('DealerCode', params.dealerCode);
                if (params.invoiceNumber) queryParams.append('InvoiceNumber', params.invoiceNumber);
                if (params.startDate) queryParams.append('StartDate', params.startDate);
                if (params.endDate) queryParams.append('EndDate', params.endDate);
                return {
                    url: `v1/DealerInvoiceApproval/warranty-team/pending-approvals?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: ['DealerInvoiceHistory']
        }),

        // Garanti Ekibi: Detay Görüntüleme
        getApprovalDetail: builder.query({
            query: (recordId) => ({
                url: `v1/DealerInvoiceApproval/warranty-team/approval-detail/${recordId}`,
                method: 'GET'
            })
        }),

        // Garanti Ekibi: Onayla
        approveDealerInvoice: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/warranty-team/approve',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['DealerInvoiceHistory', 'AllGTOrders']
        }),

        // Garanti Ekibi: Reddet
        rejectDealerInvoice: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/warranty-team/reject',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['DealerInvoiceHistory', 'AllGTOrders']
        }),

        // Garanti Ekibi: İade Et
        returnDealerInvoice: builder.mutation({
            query: (data) => ({
                url: 'v1/DealerInvoiceApproval/warranty-team/return',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['DealerInvoiceHistory', 'AllGTOrders']
        }),

        getInvoiceDetailByGroupId: builder.query({
            query: (params) => ({
                url: 'v1/DealerInvoiceApproval/invoice-detail',
                method: 'POST',
                body: {
                    GroupId: params.groupId,
                    PageNumber: params.pageNumber || 1,
                    PageSize: params.pageSize || 100
                }
            }),
            providesTags: (result, error, arg) => [
                { type: 'InvoiceDetail', id: arg.groupId }
            ]
        }),

        // Garanti Ekibi - Tüm GT Siparişleri
        getAllGTOrders: builder.query({
            query: (params) => {
                const queryParams = new URLSearchParams();
                queryParams.append('PageNumber', params.pageNumber || 1);
                queryParams.append('PageSize', params.pageSize || 10);
                queryParams.append('LanguageId', params.languageId || 1);
                if (params.status !== null && params.status !== undefined) {
                    queryParams.append('Status', params.status);
                }
                if (params.groupId) queryParams.append('GroupId', params.groupId);
                if (params.dealerCode) queryParams.append('DealerCode', params.dealerCode);
                if (params.invoiceNumber) queryParams.append('InvoiceNumber', params.invoiceNumber);
                if (params.startDate) queryParams.append('StartDate', params.startDate);
                if (params.endDate) queryParams.append('EndDate', params.endDate);
                return {
                    url: `v1/DealerInvoiceApproval/warranty-team/all-gt-orders?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: ['AllGTOrders']
        }),

        // Excel Export - Dealer Invoice
        exportDealerInvoiceToExcel: builder.mutation({
            query: (params) => ({
                url: 'v1/DealerInvoiceApproval/export-to-excel',
                method: 'POST',
                body: params
            }),
            transformResponse: (response) => {
                return response?.data || response;
            }
        })
    })
});

export const {
    useGetAvailableSapDocumentsQuery,
    useGetAllAvailableSapDocumentsForWarrantyTeamQuery,
    useGetDealerInvoiceHistoryQuery,
    useCreateDealerInvoiceMutation,
    useUpdateDealerInvoiceMutation,
    useSaveDealerInvoiceDraftMutation,
    useUpdateDealerInvoiceDraftMutation,
    useSubmitDealerInvoiceDraftMutation,
    // Doküman işlemleri
    useUploadInvoiceDocumentMutation,
    useGetInvoiceDocumentByIdQuery,
    useLazyGetInvoiceDocumentByIdQuery,
    useDeleteInvoiceDocumentMutation,
    // Garanti ekibi işlemleri
    useGetPendingApprovalsForWarrantyTeamQuery,
    useGetApprovalDetailQuery,
    useApproveDealerInvoiceMutation,
    useRejectDealerInvoiceMutation,
    useReturnDealerInvoiceMutation,
    useGetInvoiceDetailByGroupIdQuery,
    useLazyGetInvoiceDetailByGroupIdQuery,
    // YENİ
    useGetAllGTOrdersQuery,
    useExportDealerInvoiceToExcelMutation
} = dealerInvoiceEntryApi;
